module.exports = __webpack_public_path__ + "static/img/fluent-arrow-download-24-regular.389d2364.svg";